import { createSlice } from "@reduxjs/toolkit";
import transactionApi from "./api";

const initialState = {
  transactions: [],
  pagination: { current: 1, pageSize: 10 },
  isLoading: false,
  isProcessing: false,
  isCompleted: false,
};

export const comboTransactionSlice = createSlice({
  name: "bike-combo-transaction",
  initialState,
  reducers: {
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setIsProcessing: (state, action) => {
      if (action.payload === true) state.isCompleted = false;
      state.isProcessing = action.payload;
    },
    setIsCompleted: (state, action) => {
      state.isCompleted = action.payload;
    },
    setTransactions: (state, action) => {
      state.transactions = action.payload;
    },
    setPagination: (state, action) => {
      state.pagination = action.payload;
    },
  },
});

export const {
  setIsLoading,
  setIsCompleted,
  setIsProcessing,
  setTransactions,
  setPagination,
} = comboTransactionSlice.actions;

export const fetchTransactions = (params) => {
  return async (dispatch) => {
    dispatch(setIsLoading(true));
    try {
      const data = await transactionApi.getAll(params);
      dispatch(setTransactions(data.data));
      dispatch(setPagination(data.meta));
    } catch (err) {
      console.log(err);
    } finally {
      dispatch(setIsLoading(false));
    }
  };
};
export default comboTransactionSlice.reducer;
